import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// Типы для meta данных роутов
export interface RouteMeta {
  access: 'guest' | 'user' | 'admin'
}

// Расширяем стандартный тип роута
declare module 'vue-router' {
  interface _RouteRecordBase {
    meta?: RouteMeta
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Main',
    meta: { access: 'guest' },
    component: () => import('../pages/Main.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: { access: 'guest' },
    component: () => import('../pages/About.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    meta: { access: 'guest' },
    component: () => import('../pages/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    meta: { access: 'guest' },
    component: () => import('../pages/Privacy.vue')
  },
  {
    path: '/contacts',
    name: 'Contacts',
    meta: { access: 'guest' },
    component: () => import('../pages/Contacts.vue')
  },
  {
    path: '/pairs',
    name: 'Pairs',
    meta: { access: 'guest' },
    component: () => import('../pages/Pairs.vue')
  },
  {
    path: '/pairs-quantfury',
    name: 'PairsQuantfury',
    meta: { access: 'guest' },
    component: () => import('../pages/PairsQuantfury.vue')
  },
  {
    path: '/pair',
    redirect: '/pairs',
  },
  {
    path: '/pair/:codePrimary-:codeSecondary',
    name: 'PagePairRoot',
    meta: { access: 'guest' },
    component: () => import('../pages/pair/Root.vue')
  },
  {
    path: '/pair/:codePrimary-:codeSecondary/graph',
    name: 'PagePairGraph',
    meta: { access: 'guest' },
    component: () => import('../pages/pair/Graph.vue')
  },
  {
    path: '/pair/:codePrimary-:codeSecondary/indicators',
    name: 'PagePairIndicatorSets',
    meta: { access: 'guest' },
    component: () => import('../pages/pair/IndicatorSets.vue')
  },
  {
    path: '/pair/:codePrimary-:codeSecondary/candles',
    name: 'PagePairCandles',
    meta: { access: 'guest' },
    component: () => import('../pages/pair/Candles.vue')
  },
  {
    path: '/pair/:codePrimary-:codeSecondary/blockchains',
    name: 'PagePairBlockchains',
    meta: { access: 'guest' },
    component: () => import('../pages/pair/Blockchains.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { access: 'user' },
    component: () => import('../pages/Profile.vue')
  },
  {
    path: '/helper',
    name: 'HelperRoot',
    meta: { access: 'user' },
    component: () => import('../pages/helper/Root.vue')
  },
  {
    path: '/helper/wallet',
    redirect: '/helper/wallets',
  },
  {
    path: '/helper/wallets',
    name: 'HelperWallets',
    meta: { access: 'user' },
    component: () => import('../pages/helper/Wallets.vue')
  },
  {
    path: '/helper/account',
    redirect: '/helper/accounts',
  },
  {
    path: '/helper/accounts',
    name: 'HelperAccounts',
    meta: { access: 'user' },
    component: () => import('../pages/helper/Accounts.vue')
  },
  {
    path: '/helper/telegram',
    name: 'HelperTelegram',
    meta: { access: 'user' },
    component: () => import('../pages/helper/Telegram.vue')
  },
  {
    path: '/helper/agents',
    name: 'HelperAgents',
    meta: { access: 'user' },
    component: () => import('../pages/helper/Agents.vue')
  },
  {
    path: '/helper/history',
    name: 'HelperHistory',
    meta: { access: 'user' },
    component: () => import('../pages/helper/History.vue')
  },
  {
    path: '/admin',
    name: 'AdminRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/Admin.vue'),
  },
  {
    path: '/admin/languages',
    name: 'AdminLanguages',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Languages.vue'),
  },
  {
    path: '/admin/language/:idLanguage',
    name: 'AdminLanguageRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Root.vue'),
  },
  {
    path: '/admin/language/:idLanguage/locales',
    name: 'AdminLanguageLocale',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Locales.vue'),
  },
  {
    path: '/admin/language/countries',
    name: 'AdminLanguageCountry',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Countries.vue'),
  },
  {
    path: '/admin/language/country/:idCountry',
    name: 'AdminLanguageCountryRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/country/Root.vue'),
  },
  {
    path: '/admin/language/country/:idCountry/names',
    name: 'AdminLanguageCountryNames',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/country/Names.vue'),
  },
  {
    path: '/admin/language/entities',
    name: 'AdminLanguageEntities',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Entities.vue'),
  },
  {
    path: '/admin/language/entity/:idLanguageEntity/translations',
    name: 'AdminLanguageEntityTranslations',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/entity/Translations.vue'),
  },
  {
    path: '/admin/language/pages',
    name: 'AdminLanguagePages',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Pages.vue'),
  },
  {
    path: '/admin/language/page/:idLanguagePage/items',
    name: 'AdminLanguagePageItems',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/page/Items.vue'),
  },
  {
    path: '/admin/language/page/:idLanguagePage/item/:idLanguagePageItem/translations',
    name: 'AdminLanguagePageItemTranslations',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/page/item/Translations.vue'),
  },
  {
    path: '/admin/language/page/:idLanguagePage/translations',
    name: 'AdminLanguagePageTranslations',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/page/Translations.vue'),
  },
  {
    path: '/admin/language/groups',
    name: 'AdminLanguageGroups',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Groups.vue'),
  },
  {
    path: '/admin/language/group/:idLanguageGroup/items',
    name: 'AdminLanguageGroupItems',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/group/Items.vue'),
  },
  {
    path: '/admin/language/group/:idLanguageGroup/item/:idLanguageGroupItem/translations',
    name: 'AdminLanguageGroupItemTranslations',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/group/item/Translations.vue'),
  },
  {
    path: '/admin/language/actions',
    name: 'AdminLanguageActions',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/Actions.vue'),
  },
  {
    path: '/admin/language/action/:idAction/errors',
    name: 'AdminLanguageActionErrors',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/action/Errors.vue'),
  },
  {
    path: '/admin/language/action/:idAction/error/:idActionError/translations',
    name: 'AdminActionErrorTranslations',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/action/error/Translations.vue'),
  },
  {
    path: '/admin/language/emailTemplates',
    name: 'AdminLanguageEmailTemplates',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/EmailTemplates.vue'),
  },
  {
    path: '/admin/language/emailTemplate/:idEmailTemplate/translations',
    name: 'AdminLanguageEmailTemplateTranslations',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/language/emailTemplate/Translations.vue'),
  },
  {
    path: '/admin/indicators',
    name: 'AdminIndicators',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Indicators.vue'),
  },
  {
    path: '/admin/indicator/:idIndicator',
    name: 'AdminIndicatorRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/indicator/Root.vue'),
  },
  {
    path: '/admin/indicator/:idIndicator/params',
    name: 'AdminIndicatorParams',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/indicator/Params.vue'),
  },
  {
    path: '/admin/indicator/:idIndicator/outs',
    name: 'AdminIndicatorOuts',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/indicator/Outs.vue'),
  },
  {
    path: '/admin/indicator/:idIndicator/sets',
    name: 'AdminIndicatorSets',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/indicator/Sets.vue'),
  },
  {
    path: '/admin/currencies',
    name: 'AdminCurrency',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Currencies.vue'),
  },
  {
    path: '/admin/currency/:idCurrency',
    name: 'AdminCurrencyRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/currency/Root.vue'),
  },
  {
    path: '/admin/currency/:idCurrency/blockchains',
    name: 'AdminCurrencyBlockchains',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/currency/Blockchains.vue'),
  },
  {
    path: '/admin/global/currencies',
    name: 'AdminGlobalCurrencies',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/Currencies.vue'),
  },
  {
    path: '/admin/global/pairs',
    name: 'AdminGlobalPairs',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/Pairs.vue'),
  },
  {
    path: '/admin/global/pair/:idGlobalPair',
    name: 'AdminGlobalPairRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/pair/Root.vue'),
  },
  {
    path: '/admin/global/pair/:idGlobalPair/exchanges',
    name: 'AdminGlobalPairExchanges',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/pair/Exchanges.vue'),
  },
  {
    path: '/admin/global/pair/:idGlobalPair/indicators',
    name: 'AdminGlobalPairIndicators',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/pair/Indicators.vue'),
  },
  {
    path: '/admin/global/pair/:idGlobalPair/calc',
    name: 'AdminGlobalPairCalc',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/pair/Calc.vue'),
  },
  {
    path: '/admin/global/pair/:idGlobalPair/data',
    name: 'AdminGlobalPairData',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/global/pair/Data.vue'),
  },
  {
    path: '/admin/agents',
    name: 'AdminAgents',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Agents.vue'),
  },
  {
    path: '/admin/tradeGroups',
    name: 'AdminTradeGroups',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/TradeGroups.vue'),
  },
  {
    path: '/admin/settings',
    name: 'AdminSettings',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Settings.vue'),
  },
  {
    path: '/admin/backups',
    name: 'AdminBackups',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Backups.vue'),
  },
  {
    path: '/admin/store',
    name: 'AdminStore',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Store.vue'),
  },
  {
    path: '/admin/store/:indexExchange',
    name: 'AdminStoreExchange',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/store/Exchange.vue'),
  },
  {
    path: '/admin/calc',
    name: 'AdminCalc',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Calc.vue'),
  },
  {
    path: '/admin/calc/logs',
    name: 'AdminCalcLogs',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/calc/Logs.vue'),
  },
  {
    path: '/admin/tasks',
    name: 'AdminTasks',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Tasks.vue'),
  },
  {
    path: '/admin/exchanges',
    name: 'AdminExchanges',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Exchanges.vue'),
  },
  {
    path: '/admin/exchange/:idExchange',
    name: 'AdminExchangeRoot',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/exchange/Root.vue'),
  },
  {
    path: '/admin/exchange/:idExchange/currencies',
    name: 'AdminExchangeCurrencies',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/exchange/Currencies.vue'),
  },
  {
    path: '/admin/exchange/:idExchange/pairs',
    name: 'AdminExchangePairs',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/exchange/Pairs.vue'),
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Users.vue'),
  },
  {
    path: '/admin/blockchains',
    name: 'AdminBlockchains',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/Blockchains.vue'),
  },
  {
    path: '/admin/blockchain/:idBlockchain/addresses',
    name: 'AdminBlockchainAddresses',
    meta: { access: 'admin' },
    component: () => import('../pages/admin/blockchain/Addresses.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: 'PageNotFound',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 